module.exports = __webpack_public_path__ + "img/prod.40caeae1.jpg";